import { PLANNING_CONTRACTS } from "./contracts";
import { DATE_FIELDS } from "./dateFields";

const Capítulos = (type) => ({
  entity: "bloco",
  schedulerType: "capítulo",
  endpoints: {
    get: "planning/dramaturgylong",
    post: ({ key }) => `planning/${key}`,
    put: ({ key }) => `planning/${key}`,
  },
  dataKey: "blocks",
  messages: {
    uploadMessage: "dos arquivos de capítulos aqui",
    createMessage: "+ Criar Planejamento",
    noAttachmentsMessage:
      type === "projectSheet"
        ? "Nenhum anexo vinculado a este capítulo"
        : "Nenhum texto liberado com anexo",
    postMessages: {
      success: "Planejamento cadastrado com sucesso!",
      error: "Erro ao cadastrar planejamento",
    },
    putMessages: {
      success: "Planejamento editado com sucesso!",
      error: "Erro ao editar planejamento",
    },
  },
  dateFields: {
    create: DATE_FIELDS.dateFieldsForDramaturgyLongPlanningPost,
    edit: DATE_FIELDS.dateFieldsForDramaturgyLongPlanningPost,
    editAttachment: DATE_FIELDS.dateFieldsForAttachmentsEditDramaturgyLong,
  },
  postBody: ({ key, payload }) =>
    key === "materials"
      ? PLANNING_CONTRACTS.postDramaturgyShortPlanning(payload)
      : PLANNING_CONTRACTS.postBlock(payload),
  patchBody: ({ key, payload }) =>
    key === "materials"
      ? PLANNING_CONTRACTS.patchMaterials(payload)
      : PLANNING_CONTRACTS.patchBlock(payload),
});

const Materiais = () => ({
  entity: "material",
  schedulerType: "",
  endpoints: {
    get: "planning",
    post: ({ key }) => `planning/${key}`,
    put: ({ key }) => `planning/${key}`,
  },
  dataKey: "materials",
  messages: {
    uploadMessage: "dos arquivos aqui",
    createMessage: "+ Criar Planejamento",
    noAttachmentsMessage: "Nenhum planejamento criado para este material",
    noLinkedFileMessage: "Nenhum anexo vinculado a este material",
    postMessages: {
      success: "Planejamento cadastrado com sucesso!",
      error: "Erro ao cadastrar planejamento",
    },
    putMessages: {
      success: "Planejamento editado com sucesso!",
      error: "Erro ao editar planejamento",
    },
  },
  dateFields: {
    create: DATE_FIELDS.dateFieldsForDramaturgyShortPlanning,
    edit: DATE_FIELDS.dateFieldsForDramaturgyShortPlanning,
    editAttachment: DATE_FIELDS.dateFieldsForAttachmentsEditDramaturgyShort,
  },
  postBody: ({ payload }) =>
    PLANNING_CONTRACTS.postDramaturgyShortPlanning(payload),
  patchBody: ({ payload }) => PLANNING_CONTRACTS.patchMaterials(payload),
});

export const planningTypesByContentType = (schedulerType, context) => {
  const types = {
    "Capítulos/Sinopse": Capítulos(context),
    Materiais: Materiais(),
  };

  return types[schedulerType] || null;
};
